import { currency } from '@alfalab/data';

/**
 * Возвращает знак валюты по ISO коду.
 *
 * @param currencyCode Код валюты.
 */
const getCurrencySymbol = (currencyCode) => currency.CURRENCY_SYMBOLS[currencyCode];

export { getCurrencySymbol };
